var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page padded add-new-room"},[_c('add-content-renderer',{attrs:{"entity":_vm.entity,"form":_vm.formModel,"submit-async":_vm.addAsync},on:{"update:entity":function($event){_vm.entity=$event},"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }